import { fromJS, Map } from 'immutable'
import TranslationConstants from 'constants/TranslationConstants'

/**
* Store mapping locale key to messages
*/
class TranslationStore extends Marty.Store {
  state = Map()
  handlers = {
    updateTranslations: [TranslationConstants.TRANSLATION_LOADED]
  }

  dehydrate() {
    return this.state.toJS()
  }

  rehydrate(dehydratedState) {
    return fromJS(dehydratedState)
  }

  getTranslationsForLocale() {
    return this.fetch({
      id: 'getTranslations',
      dependsOn: [
        this.app.stores.OrgSettingsStore.getOrgSettings(),
        this.app.stores.LocaleStore.loadLocale(),
      ],
      locally() {
        const { locale } = this.app.stores.OrgSettingsStore.state
        return this.state.get(locale)
      },
      remotely() {
        const { locale } = this.app.stores.OrgSettingsStore.state
        return this.app.actions.TranslationActions.loadTranslations(locale)
      }
    })
  }

  updateTranslations(locale, messages) {
    this.state = this.state.set(locale, messages)
  }
}

export default TranslationStore



// WEBPACK FOOTER //
// ./src/scripts/stores/TranslationStore.js